import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ExpensesListPage from './ExpensesListPage';
import ExpenseDashboard from './ExpenseDashboard';

export default function ExpensesRoutes() {
  return (
    <Routes>
      <Route index element={<ExpensesListPage />} />
      <Route path="dashboard" element={<ExpenseDashboard />} />
    </Routes>
  );
}
